<template>
  <router-view />
</template>

<script>
  import { setApiToken } from '@/api/ApiClient'

  export default {
    name: 'App',
    mounted () {
      const accessToken = localStorage.getItem('accessToken')
      if (accessToken) {
        setApiToken(accessToken)
      }
    },
  }
</script>
